(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-zv-article]';
  var CONTENT_START_ID = 'zv-article-content-start';

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initTableOfContents(section) {
    var prose = section.querySelector('[data-zv-article-content]');
    var tocList = section.querySelector('[data-zv-toc-list]');

    if (!prose || !tocList) return;

    var headings = prose.querySelectorAll('h1, h2, h3');
    var usedIds = {};

    headings.forEach(function (heading) {
      var text = heading.textContent.trim();
      if (!text) return;

      if (!heading.id) {
        var baseId = slugify(text) || 'section';
        var id = baseId;
        var counter = 2;

        while (usedIds[id] || document.getElementById(id)) {
          id = baseId + '-' + counter;
          counter += 1;
        }

        heading.id = id;
        usedIds[id] = true;
      } else {
        usedIds[heading.id] = true;
      }

      var level = heading.tagName.toLowerCase().replace('h', '');
      var item = document.createElement('li');
      var link = document.createElement('a');

      link.href = '#' + heading.id;
      link.textContent = text;
      link.setAttribute('data-level', level);
      link.setAttribute('data-zv-toc-link', '');

      item.appendChild(link);
      tocList.appendChild(item);
    });

    initTocActiveState(section, prose);
  }

  function initTocActiveState(section, prose) {
    var links = section.querySelectorAll('[data-zv-toc-link]');
    if (!links.length) return;

    var headings = Array.prototype.slice.call(
      prose.querySelectorAll('h1, h2, h3')
    );

    function setActive(id) {
      links.forEach(function (link) {
        var isActive = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', isActive);
      });
    }

    function activateStartIfNeeded() {
      if (!headings.length) {
        setActive(CONTENT_START_ID);
        return;
      }

      var firstHeadingTop = headings[0].getBoundingClientRect().top;
      if (firstHeadingTop > window.innerHeight * 0.2) {
        setActive(CONTENT_START_ID);
      }
    }

    if ('IntersectionObserver' in window) {
      var visibleMap = {};

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            visibleMap[entry.target.id] = entry.isIntersecting;
          });

          var activeHeading = headings.find(function (heading) {
            return visibleMap[heading.id];
          });

          if (activeHeading) {
            setActive(activeHeading.id);
          } else {
            activateStartIfNeeded();
          }
        },
        {
          rootMargin: '-20% 0px -70% 0px',
          threshold: 0,
        }
      );

      headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);

        if (target) {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(id);
        }
      });
    });
  }

  function initReadProgress(section) {
    var bar = section.querySelector('[data-zv-read-progress]');
    var prose = section.querySelector('[data-zv-article-content]');

    if (!bar || !prose) return;

    function updateProgress() {
      var rect = prose.getBoundingClientRect();
      var proseTop = rect.top + window.scrollY;
      var proseHeight = prose.offsetHeight;
      var viewportBottom = window.scrollY + window.innerHeight;
      var start = proseTop;
      var end = proseTop + proseHeight;
      var progress = ((viewportBottom - start) / (end - start)) * 100;

      bar.style.width = Math.min(100, Math.max(0, progress)) + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  function initCopyLink(section) {
    var buttons = section.querySelectorAll('[data-zv-copy-link]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var url = button.getAttribute('data-zv-copy-link');
        if (!url) return;

        function markCopied() {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 2000);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(markCopied).catch(function () {
            window.prompt('Copy link:', url);
          });
        } else {
          window.prompt('Copy link:', url);
          markCopied();
        }
      });
    });
  }

  function initSection(section) {
    if (section.dataset.zvArticleInit === 'true') return;
    section.dataset.zvArticleInit = 'true';

    initTableOfContents(section);
    initReadProgress(section);
    initCopyLink(section);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR) || event.target.closest(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
